import {Component, ViewEncapsulation, OnInit} from '@angular/core';
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'sport-pages',
  encapsulation: ViewEncapsulation.None,
  styles: [],
  template: `
  <div class="blue-bg">
        <router-outlet ></router-outlet>
        </div>
    `
})
export class PagesComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
